/* KOR-E header behaviour — extracted from sections/header.liquid (Batch AP, 2026-07-29).
   Was 24.8KB of inline <script> inside the document on every page; the document is on the
   FCP critical path, so this moved to a deferred, cacheable asset. The transparent-header
   offset block stays INLINE in header.liquid: it measures the rendered header height into
   --kore-transparent-header-offset, which drives the hero pull-up. Deferring it costs
   CLS 0.085 (measured). Contains no Liquid — safe as a static asset. */
  (function () {
    'use strict';

    /* ── Desktop mega/dropdown: hover with 200ms delay to bridge the gap ── */
    var drops = document.querySelectorAll('[data-kore-drop]');

    function openDrop(el) {
      drops.forEach(function (d) { if (d !== el) closeDrop(d); });
      el.classList.add('kore-hdr__nav-item--open');
      var panel = el.querySelector('.kore-hdr__mega, .kore-hdr__dropdown');
      if (panel) { panel.setAttribute('aria-hidden', 'false'); panel.removeAttribute('inert'); }
    }
    function closeDrop(el) {
      el.classList.remove('kore-hdr__nav-item--open');
      var panel = el.querySelector('.kore-hdr__mega, .kore-hdr__dropdown');
      if (panel) { panel.setAttribute('aria-hidden', 'true'); panel.setAttribute('inert', ''); }
    }

    drops.forEach(function (item) {
      var timer = null;
      function cancelClose() { if (timer) { clearTimeout(timer); timer = null; } }
      function scheduleClose() { timer = setTimeout(function () { closeDrop(item); }, 200); }

      item.addEventListener('mouseenter', function () { cancelClose(); openDrop(item); });
      item.addEventListener('mouseleave', scheduleClose);

      /* The mega panel is absolutely positioned outside item's box — keep it alive */
      var panel = item.querySelector('.kore-hdr__mega, .kore-hdr__dropdown');
      if (panel) {
        panel.addEventListener('mouseenter', cancelClose);
        panel.addEventListener('mouseleave', scheduleClose);
      }

      /* Touch: first tap opens, second tap navigates */
      var catLink = item.querySelector('[data-kore-cat-link]');
      if (catLink) {
        catLink.addEventListener('click', function (e) {
          if (!item.classList.contains('kore-hdr__nav-item--open') && window.matchMedia('(hover: none)').matches) {
            e.preventDefault();
            openDrop(item);
          }
        });
      }
    });

    document.addEventListener('click', function () { drops.forEach(closeDrop); });

    /* ── Mobile drawer ── */
    var overlay = document.getElementById('KoreMobOverlay');
    var drawer  = document.getElementById('KoreMobDrawer');
    var toggler = document.querySelector('[data-kore-mob-toggle]');

    function cleanMobBadges() {
      if (!drawer) return;
      drawer.querySelectorAll('.kore-mob__prod-link').forEach(function (link) {
        Array.prototype.slice.call(link.children).forEach(function (child) {
          if (
            !child.classList.contains('kore-mob__prod-img') &&
            !child.classList.contains('kore-mob__prod-title')
          ) {
            child.style.display = 'none';
          }
        });
      });
    }
    function openMob() {
      if (!overlay || !drawer) return;
      /* Category thumbnails are deferred (data-kore-mob-src) so a closed drawer does
         not compete for LCP bandwidth. The parse-time block in header.liquid binds
         this to the toggler and exposes it here; call it too so programmatic opens
         (anything that is not a toggler click) still get their images. */
      if (window.koreMobLoadImgs) window.koreMobLoadImgs();
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      /* The drawer ships with `inert` so its links are neither focusable nor
         announced while closed (axe aria-hidden-focus). It MUST come off on open
         or the whole mobile menu is untappable — inert blocks hit-testing, so
         taps land on the overlay behind it. */
      drawer.removeAttribute('inert');
      if (toggler) toggler.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () { setTimeout(cleanMobBadges, 80); });
    }
    function closeAllMobAccordions() {
      if (!drawer) return;
      drawer.querySelectorAll('.kore-mob__acc-btn[aria-expanded="true"]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      drawer.querySelectorAll('.kore-mob__products.is-open').forEach(function (panel) {
        panel.classList.remove('is-open');
        panel.setAttribute('hidden', '');
      });
      drawer.querySelectorAll('.kore-mob__sub-btn[aria-expanded="true"]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      drawer.querySelectorAll('.kore-mob__sub.is-open').forEach(function (panel) {
        panel.classList.remove('is-open');
        panel.setAttribute('hidden', '');
      });
    }
    function closeMob() {
      if (!overlay || !drawer) return;
      closeAllMobAccordions();
      overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      if (toggler) toggler.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (toggler) toggler.addEventListener('click', openMob);
    document.querySelectorAll('[data-kore-mob-close]').forEach(function (el) {
      el.addEventListener('click', closeMob);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMob(); } });

    /* ── Mobile accordion: product panels ── */
    (drawer ? drawer.querySelectorAll('.kore-mob__acc-btn') : []).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        /* Navigate: btn → .kore-mob__row → parent <li> (works for both top-level and nested items) */
        var row  = btn.parentElement;
        var item = row ? row.parentElement : null;
        var panel = item ? item.querySelector('.kore-mob__products') : null;
        if (!panel) return;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        /* Close other product panels without touching sub panels */
        drawer.querySelectorAll('.kore-mob__acc-btn[aria-expanded="true"]').forEach(function (b) {
          if (b === btn) return;
          b.setAttribute('aria-expanded', 'false');
          var r = b.parentElement;
          var it = r ? r.parentElement : null;
          var p = it ? it.querySelector('.kore-mob__products') : null;
          if (p) { p.classList.remove('is-open'); p.setAttribute('hidden', ''); }
        });
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          panel.classList.add('is-open');
          panel.removeAttribute('hidden');
          requestAnimationFrame(cleanMobBadges);
        } else {
          btn.setAttribute('aria-expanded', 'false');
          panel.classList.remove('is-open');
          panel.setAttribute('hidden', '');
        }
      });
    });

    /* ── Mobile sub-menu: parent panels ── */
    (drawer ? drawer.querySelectorAll('.kore-mob__sub-btn') : []).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var row  = btn.parentElement;
        var item = row ? row.parentElement : null;
        var panel = item ? item.querySelector('.kore-mob__sub') : null;
        if (!panel) return;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        /* Close all product panels */
        drawer.querySelectorAll('.kore-mob__acc-btn[aria-expanded="true"]').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
        });
        drawer.querySelectorAll('.kore-mob__products.is-open').forEach(function (p) {
          p.classList.remove('is-open'); p.setAttribute('hidden', '');
        });
        /* Close other sub panels */
        drawer.querySelectorAll('.kore-mob__sub-btn[aria-expanded="true"]').forEach(function (b) {
          if (b === btn) return;
          b.setAttribute('aria-expanded', 'false');
          var r = b.parentElement;
          var it = r ? r.parentElement : null;
          var p = it ? it.querySelector('.kore-mob__sub') : null;
          if (p) { p.classList.remove('is-open'); p.setAttribute('hidden', ''); }
        });
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          panel.classList.add('is-open');
          panel.removeAttribute('hidden');
        } else {
          btn.setAttribute('aria-expanded', 'false');
          panel.classList.remove('is-open');
          panel.setAttribute('hidden', '');
        }
      });
    });

    

    /* ── Mobile Inline Search (completely separate from desktop #kore-search-drop) ── */
    (function () {
      var isWrap  = document.getElementById('KoreMobISearch');
      var isInp   = document.getElementById('KoreMobISearchInp');
      var isClose = document.getElementById('KoreMobISearchClose');
      var isBtn   = document.querySelector('[data-kore-mob-search-open]');
      if (!isWrap || !isInp) return;

      /* Dedicated mobile dropdown — never affects desktop */
      var isDrop = document.createElement('div');
      isDrop.id  = 'kore-mob-isearch-drop';
      document.body.appendChild(isDrop);

      var DEBOUNCE = 200;
      var LIMIT    = 8;
      var isTimer  = null;
      var isAbort  = null;

      /* Popular searches — shown on empty input */
      var POPULAR = [
        { label: 'MODO',          url: '/search?q=MODO'           },
        { label: 'LOUNGE MASTER', url: '/search?q=LOUNGE%20MASTER' },
        { label: 'DOZE',          url: '/search?q=DOZE'           }
      ];

      function isEsc(s) {
        return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
      }
      function isThumb(src) {
        if (!src) return '';
        if (src.indexOf('//') === 0) src = 'https:' + src;
        return src.replace(/\.(jpe?g|png|gif|webp)/i, '_120x120.$1');
      }
      function isPriceFmt(p) {
        var n = parseFloat(p.price);
        if (!n || isNaN(n)) return '';
        return '₪' + String(p.price).replace(/\.00$/, '');
      }

      function positionIsDrop() {
        var hdr = document.querySelector('.section-header');
        var top = hdr ? Math.round(hdr.getBoundingClientRect().bottom) : 0;
        isDrop.style.top       = top + 'px';
        isDrop.style.maxHeight = (window.innerHeight - top - 8) + 'px';
      }
      function showIsDrop(html) {
        isDrop.innerHTML = html;
        positionIsDrop();
        isDrop.style.display = 'block';
      }
      function hideIsDrop() {
        isDrop.style.display = 'none';
        isDrop.innerHTML     = '';
      }

      function showPopular() {
        var html = '<p class="kore-misd__pop-title">חיפושים פופולריים</p>';
        POPULAR.forEach(function (item) {
          html += '<a href="' + isEsc(item.url) + '" class="kore-misd__pop-link">' + isEsc(item.label) + '</a>';
        });
        showIsDrop(html);
      }

      function isProdRow(p) {
        var pr  = isPriceFmt(p);
        var src = p.image || (p.featured_image && (p.featured_image.url || p.featured_image.src)) || '';
        var t   = isThumb(src);
        var imgHtml = t
          ? '<img class="kore-misd__pic" src="' + isEsc(t) + '" alt="' + isEsc(p.title) + '" loading="lazy">'
          : '<span class="kore-misd__pic"></span>';
        return '<a href="' + isEsc(p.url) + '" class="kore-misd__row">' +
          '<span class="kore-misd__meta">' +
            '<span class="kore-misd__name">' + isEsc(p.title) + '</span>' +
            (pr ? '<span class="kore-misd__price">' + pr + '</span>' : '') +
          '</span>' +
          imgHtml +
        '</a>';
      }

      function doIsearch(q) {
        try { if (isAbort) isAbort.abort(); } catch(e) {}
        try { isAbort = new AbortController(); } catch(e) { isAbort = null; }

        var _srBase = (window.routes && window.routes.predictive_search_url)
          ? window.routes.predictive_search_url
          : '/search/suggest';
        var url = _srBase
          + '?q=' + encodeURIComponent(q)
          + '&resources%5Btype%5D=product'
          + '&resources%5Blimit%5D=' + LIMIT
          + '&section_id=predictive-search';

        fetch(url, isAbort ? { signal: isAbort.signal } : {})
          .then(function (r) {
            if (!r.ok) { hideIsDrop(); return Promise.reject(null); }
            return r.text();
          })
          .then(function (html) {
            var doc   = new DOMParser().parseFromString(html, 'text/html');
            var items = doc.querySelectorAll('#predictive-search-results-products-list .predictive-search__list-item a');
            if (!items.length) { hideIsDrop(); return; }
            var rows = '';
            items.forEach(function (a) {
              var imgEl   = a.querySelector('img.predictive-search__image');
              var titleEl = a.querySelector('.predictive-search__item-heading');
              var priceEl = a.querySelector('.price-item--regular, .price-item--sale.price-item--last, .price-item');
              var title     = titleEl ? titleEl.textContent.trim() : '';
              var href      = a.getAttribute('href') || '';
              var imgSrc    = imgEl ? imgEl.getAttribute('src') : '';
              var priceText = priceEl ? priceEl.textContent.trim() : '';
              if (imgSrc && imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
              var imgHtml = imgSrc
                ? '<img class="kore-misd__pic" src="' + isEsc(imgSrc) + '" alt="' + isEsc(title) + '" loading="lazy">'
                : '<span class="kore-misd__pic"></span>';
              rows += '<a href="' + isEsc(href) + '" class="kore-misd__row">'
                + '<span class="kore-misd__meta">'
                  + '<span class="kore-misd__name">' + isEsc(title) + '</span>'
                  + (priceText ? '<span class="kore-misd__price">' + isEsc(priceText) + '</span>' : '')
                + '</span>'
                + imgHtml
              + '</a>';
            });
            showIsDrop(rows);
          })
          .catch(function (e) {
            if (!e || e.name === 'AbortError') return;
            hideIsDrop();
          });
      }

      function openIsearch() {
        isWrap.classList.add('is-open');
        isWrap.setAttribute('aria-hidden', 'false');
        isInp.focus(); /* direct focus call in gesture handler — required for iOS keyboard */
        showPopular();
      }
      function closeIsearch() {
        isWrap.classList.remove('is-open');
        isWrap.setAttribute('aria-hidden', 'true');
        isInp.value = '';
        hideIsDrop();
      }

      if (isBtn)   isBtn.addEventListener('click',   openIsearch);
      if (isClose) isClose.addEventListener('click', closeIsearch);

      isInp.addEventListener('input', function () {
        clearTimeout(isTimer);
        var q = (isInp.value || '').trim();
        if (!q) { showPopular(); return; }
        isTimer = setTimeout(function () { doIsearch(q); }, DEBOUNCE);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isWrap.classList.contains('is-open')) closeIsearch();
      });

      window.addEventListener('resize', function () {
        if (isDrop.style.display !== 'none') positionIsDrop();
      }, { passive: true });
    }());

    /* ── KOR-E Live Search ── */
    (function () {
      var DEBOUNCE = 200;
      var LIMIT    = 8;
      var timer    = null;
      var abortCtrl = null;
      var activeInp = null;

      var deskInp = document.getElementById('Search-In-Modal');
      var mobInp  = document.querySelector('.kore-mob__search-input');
      if (!deskInp && !mobInp) return;

      /* dropdown element — appended to <body> to escape all stacking contexts */
      var drop = document.createElement('div');
      drop.id = 'kore-search-drop';
      drop.setAttribute('aria-live', 'polite');
      document.body.appendChild(drop);

      /* ── helpers ── */
      function esc(s) {
        return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
      }
      function thumb(src) {
        if (!src) return '';
        if (src.indexOf('//') === 0) src = 'https:' + src;
        return src.replace(/\.(jpe?g|png|gif|webp)/i, '_96x96.$1');
      }
      function fmtPrice(p) {
        var n = parseFloat(p.price);
        if (!n || isNaN(n)) return '';
        return '₪' + String(p.price).replace(/\.00$/, '');
      }

      /* ── positioning ── */
      function positionDrop() {
        if (!activeInp) return;
        var section = document.querySelector('.section-header');
        var top;
        if (section && activeInp === deskInp) {
          top = Math.round(section.getBoundingClientRect().bottom);
        } else {
          top = Math.round(activeInp.getBoundingClientRect().bottom) + 4;
        }
        drop.style.top = top + 'px';
        drop.style.maxHeight = (window.innerHeight - top - 4) + 'px';
      }

      function showDrop(html) {
        drop.innerHTML = '<div class="kore-sd__inner">' + html + '</div>';
        positionDrop();
        drop.style.display = 'block';
      }
      function hideDrop() {
        drop.style.display = 'none';
        drop.innerHTML = '';
      }

      /* ── row builders ── */
      function imgEl(src, alt) {
        var t = thumb(src);
        return t
          ? '<img class="kore-sd__pic" src="' + esc(t) + '" alt="' + esc(alt) + '" width="44" height="44" loading="lazy">'
          : '<span class="kore-sd__nopic"></span>';
      }
      function productRow(p) {
        var pr = fmtPrice(p);
        var imgSrc = p.image || (p.featured_image && (p.featured_image.url || p.featured_image.src)) || '';
        return '<a href="' + esc(p.url) + '" class="kore-sd__row">' +
          imgEl(imgSrc, p.title) +
          '<span class="kore-sd__meta">' +
            '<span class="kore-sd__name">' + esc(p.title) + '</span>' +
            (pr ? '<span class="kore-sd__price">' + pr + '</span>' : '') +
          '</span>' +
        '</a>';
      }
      function collectionRow(c) {
        return '<a href="' + esc(c.url) + '" class="kore-sd__row">' +
          imgEl(c.image || '', c.title) +
          '<span class="kore-sd__meta">' +
            '<span class="kore-sd__name">' + esc(c.title) + '</span>' +
            '<span class="kore-sd__badge">קטגוריה</span>' +
          '</span>' +
        '</a>';
      }

      /* ── fetch ── */
      function doSearch(q) {
        try { if (abortCtrl) abortCtrl.abort(); } catch(e) {}
        try { abortCtrl = new AbortController(); } catch(e) { abortCtrl = null; }

        showDrop('<p class="kore-sd__hint">מחפש…</p>');

        var _srBase = (window.routes && window.routes.predictive_search_url)
          ? window.routes.predictive_search_url
          : '/search/suggest';
        var url = _srBase
          + '?q=' + encodeURIComponent(q)
          + '&resources%5Btype%5D=product%2Ccollection'
          + '&resources%5Blimit%5D=' + LIMIT
          + '&section_id=predictive-search';

        fetch(url, abortCtrl ? { signal: abortCtrl.signal } : {})
          .then(function(r) {
            if (!r.ok) { hideDrop(); return Promise.reject(null); }
            return r.text();
          })
          .then(function(html) {
            var doc   = new DOMParser().parseFromString(html, 'text/html');

            /* products */
            var prods = [];
            doc.querySelectorAll('#predictive-search-results-products-list .predictive-search__list-item a').forEach(function(a) {
              var imgEl   = a.querySelector('img.predictive-search__image');
              var titleEl = a.querySelector('.predictive-search__item-heading');
              var priceEl = a.querySelector('.price-item--regular, .price-item--sale.price-item--last, .price-item');
              var imgSrc  = imgEl ? imgEl.getAttribute('src') : '';
              if (imgSrc && imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
              prods.push({
                url:       a.getAttribute('href') || '',
                title:     titleEl ? titleEl.textContent.trim() : '',
                image:     imgSrc,
                priceText: priceEl ? priceEl.textContent.trim() : ''
              });
            });

            /* collections (in queries list, each li id contains "collection") */
            var cols = [];
            doc.querySelectorAll('#predictive-search-results-queries-list li[id*="collection"] a').forEach(function(a) {
              var titleEl = a.querySelector('.predictive-search__item-heading');
              cols.push({
                url:   a.getAttribute('href') || '',
                title: titleEl ? titleEl.textContent.trim() : ''
              });
            });

            if (!prods.length && !cols.length) {
              showDrop('<p class="kore-sd__empty">לא נמצאו תוצאות</p>');
              return;
            }

            var out = '';
            if (prods.length) {
              out += '<div class="kore-sd__section"><p class="kore-sd__label">מוצרים</p>';
              prods.forEach(function(p) {
                var imgHtml = p.image
                  ? '<img class="kore-sd__pic" src="' + esc(p.image) + '" alt="' + esc(p.title) + '" width="44" height="44" loading="lazy">'
                  : '<span class="kore-sd__nopic"></span>';
                out += '<a href="' + esc(p.url) + '" class="kore-sd__row">'
                  + imgHtml
                  + '<span class="kore-sd__meta">'
                    + '<span class="kore-sd__name">' + esc(p.title) + '</span>'
                    + (p.priceText ? '<span class="kore-sd__price">' + esc(p.priceText) + '</span>' : '')
                  + '</span>'
                + '</a>';
              });
              out += '</div>';
            }
            if (cols.length) {
              out += '<div class="kore-sd__section"><p class="kore-sd__label">קטגוריות</p>';
              cols.forEach(function(c) {
                out += '<a href="' + esc(c.url) + '" class="kore-sd__row">'
                  + '<span class="kore-sd__nopic"></span>'
                  + '<span class="kore-sd__meta">'
                    + '<span class="kore-sd__name">' + esc(c.title) + '</span>'
                    + '<span class="kore-sd__badge">קטגוריה</span>'
                  + '</span>'
                + '</a>';
              });
              out += '</div>';
            }
            showDrop(out);
          })
          .catch(function(e) {
            if (!e || e.name === 'AbortError') return;
            hideDrop();
          });
      }

      /* ── wire up an input ── */
      function attachInput(inp) {
        if (!inp) return;
        inp.addEventListener('input', function() {
          clearTimeout(timer);
          var q = (inp.value || '').trim();
          if (!q) { hideDrop(); return; }
          activeInp = inp;
          timer = setTimeout(function() { doSearch(q); }, DEBOUNCE);
        });
        if (inp.form) {
          inp.form.addEventListener('reset', function() { hideDrop(); });
        }
      }
      attachInput(deskInp);
      attachInput(mobInp);

      /* ── close: outside click ── */
      var deskModal = deskInp && deskInp.closest('.header__search');
      var mobArea   = mobInp  && mobInp.closest('.kore-mob__search');
      document.addEventListener('click', function(e) {
        if (drop.style.display === 'none') return;
        var inside = drop.contains(e.target) ||
          (deskModal && deskModal.contains(e.target)) ||
          (mobArea   && mobArea.contains(e.target));
        if (!inside) hideDrop();
      });

      /* ── close: Escape ── */
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') hideDrop();
      });

      /* ── close: desktop search modal toggles shut ── */
      var details = document.querySelector('.section-header details');
      if (details) {
        details.addEventListener('toggle', function() {
          if (!details.open) {
            hideDrop();
            if (deskInp) deskInp.value = '';
          }
        });
      }

      /* ── close: mobile drawer close buttons ── */
      document.querySelectorAll('[data-kore-mob-close]').forEach(function(el) {
        el.addEventListener('click', function() {
          hideDrop();
          if (mobInp) mobInp.value = '';
        });
      });

      /* ── reposition on resize ── */
      window.addEventListener('resize', function() {
        if (drop.style.display !== 'none') positionDrop();
      }, { passive: true });
    }());

  }());
